import { FaArrowUpLong, FaArrowDownLong } from "react-icons/fa6";
import { ArrowUpDown } from "lucide-react"
import { useState } from "react";

type ISortedHeaderProps = {
  title: string | React.ReactNode;
  column: any;
  setOrder?: (oder: { [key: string | number]: string; }) => void;
  orderName?: string;
  sortedState?: { [key: string | number]: string; };
};

export const SortedHeader = ({
  column,
  title,
  setOrder,
  orderName,
  sortedState
}: ISortedHeaderProps) => {

  const initialSorted = sortedState ? sortedState[orderName ?? column.id] : undefined
  const [sorted, setSorted] = useState<string | false>(initialSorted ?? column.getIsSorted());

  return (
    <div
      className="flex items-center gap-1"
      onClick={() => {
        const oldSorted = sorted.toString()

        const newSorted = (oldSorted === "false" || oldSorted === "")
          ? "desc"
          : (sorted === "desc" ? "asc" : "")

          const newOrder = {
          [orderName ?? column.id]: newSorted,
        };
        
        setSorted(newSorted);
        if (setOrder) {
          setOrder(newOrder);
        }

        column.toggleSorting(undefined);
      }}
    >
      {title}
      {(sorted && sorted.length) ? (sorted === "asc" ? <FaArrowUpLong /> : <FaArrowDownLong />) : <ArrowUpDown className="ml-1 h-4 w-4" />}
    </div>
  );
};
